<template>
  <div class="day-recipe">
    <div class="day-title">{{ currentMonth }}膳食</div>
    <div class="week-item">
      <div
        class="week-item-title"
        :class="{ week_active: currentWeek === item }"
        v-for="(item, index) in weekTitles"
        :key="index"
      >
        {{ item }}
      </div>
    </div>
    <div class="week-day">
      <div
        @click="handleChangeDay(item)"
        class="week-item-day"
        :class="{ active: currentWeek === item.week }"
        v-for="(item, index) in dayArr"
        :key="index"
      >
        {{ item.days }}
      </div>
    </div>
    <van-divider />
    <template v-if="currentRecipeData.length === 0">
      <div class="no-day-recipe">
        <img src="@/assets/home/no-day-recipe.svg" alt="" />
        <p>今日无食谱</p>
      </div>
    </template>
    <template v-else>
      <div
        v-for="(item, index) in currentRecipeData"
        :key="index"
        class="day-item"
      >
        <div class="day-item-title">
          <img
            v-if="item.type === 1"
            src="@/assets/home/Dinner_breakfast.svg"
            alt=""
          />
          <img
            v-else-if="item.type === 2"
            src="@/assets/home/Dinner_b.svg"
            alt=""
          />
          <img
            v-else-if="item.type === 3"
            src="@/assets/home/Dinner_lunch.svg"
            alt=""
          />
          <img
            v-else-if="item.type === 4"
            src="@/assets/home/Dinner_l.svg"
            alt=""
          />
          <img
            v-else-if="item.type === 5"
            src="@/assets/home/Dinner_supper.svg"
            alt=""
          />
          <img
            v-else-if="item.type === 6"
            src="@/assets/home/Dinner_s.svg"
            alt=""
          />
          <span v-if="item.type === 1">早餐</span>
          <span v-else-if="item.type === 2">早点</span>
          <span v-else-if="item.type === 3">午餐</span>
          <span v-else-if="item.type === 4">午点</span>
          <span v-else-if="item.type === 5">晚餐</span>
          <span v-else-if="item.type === 6">晚点</span>
        </div>
        <div
          v-for="(ele, index) in item.foods"
          :key="index"
          class="food-item"
        >
          <img
            v-if="ele.pic"
            src="https://huayuan-group-meal-public.oss-cn-hangzhou.aliyuncs.com/mini-app/me/purple.svg"
            alt=""
          />
          <img
            v-else
            src="@/assets/home/default_food.svg"
            alt=""
          />
          <div class="van-hairline--bottom">{{ ele.dishName }}</div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { getAllDate } from "@/util/formatDate";
export default {
  name: "DayRecipe",
  props: {
    currentRecipe: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    currentWeek:{
      type:String
    }
  },
  watch: {
    currentWeek(){
      this.formatRecipe(this.currentRecipe)
    }
  },
  data() {
    return {
      currentMonth: '', // 当前月份
      weekTitles: ["一", "二", "三", "四", "五", "六", "日"],
      dayArr: [], // 存放当前周日期
      currentRecipeData: [], // 选中天的食谱
      weekOne:[],
      weekTwo:[],
      weekThree: [],
      weekFour: [],
      weekFive: [],
      weekSix: [],
      weekSeven:[]
    };
  },
  mounted() {
    // console.log(this.currentRecipe);
    this.init(this.currentRecipe);
  },
  methods: {
    // 统一初始化函数
    init(data) {
      this.formatRecipe(data);
    },
    // 食谱数据转换
    formatRecipe(data) {
      this.currentRecipeData = []
      data.recipeCycles.forEach((ele) => {
        if(this.currentWeek === '一' && ele.week === 1){
          this.currentRecipeData.push({
            type: ele.mealsType,
            foods: ele.recipeConncts
          })
        } else if(this.currentWeek === '二' && ele.week ===2){
          this.currentRecipeData.push({
            type: ele.mealsType,
            foods:ele.recipeConncts
          })
        } else if(this.currentWeek === '三' && ele.week ===3){
          this.currentRecipeData.push({
            type: ele.mealsType,
            foods:  ele.recipeConncts
          })
        } else if(this.currentWeek === '四' && ele.week === 4){
          this.currentRecipeData.push({
            type: ele.mealsType,
            foods: ele.recipeConncts
          })
        } else if(this.currentWeek === '五' && ele.week === 5){
          this.currentRecipeData.push({
            type: ele.mealsType,
            foods: ele.recipeConncts
          })
        } else if(this.currentWeek === '六' && ele.week ===6){
          this.currentRecipeData.push({
            type: ele.mealsType,
            foods: ele.recipeConncts
          })
        } else if(this.currentWeek === '日' && ele.week ===7){
          this.currentRecipeData.push({
            type: ele.mealsType,
            foods: ele.recipeConncts
          })
        }
      this.dayArr = getAllDate(data.startTime, data.endTime);
      this.dayArr.forEach((ele) =>ele.week === this.currentWeek ? (this.currentMonth = ele.mmd) : "")
      })
    },
    // 改变选中天
    handleChangeDay(item){
      this.$emit('update-week',item.week)
      this.currentMonth = item.mmd
    },
  },
};
</script>

<style lang="less" scope>
.day-recipe {
  margin-top: 0.3rem;
  padding: 0.3rem;
  border-radius: 0.2rem;
  background-color: #fff;
  .day-title {
    margin-left: 0.1rem;
    font-size: 0.4rem;
    font-weight: 500;
    font-family: PingFangSC, PingFangSC-Medium;
    color: #000000;
  }
  .week-item {
    margin-top: 0.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    color: rgba(0, 0, 0, 0.38);
    font-family: PingFangSC, PingFangSC-Semibold;
    .week-item-title {
      width: calc(100% / 7);
      height: calc(100% / 7);
      text-align: center;
      font-size: 0.28rem;
      font-family: PingFangSC, PingFangSC-Semibold;
      font-weight: normal;
    }
  }
  .week_active {
    color: #000000;
    font-family: PingFangSC, PingFangSC-Semibold;
    font-weight: 600;
  }
  .week-day {
    margin-top: 0.2rem;
    display: flex;
    width: 100%;
    color: rgba(0, 0, 0, 0.38);
    font-family: DINAlternate, DINAlternate-Bold;
    font-weight: 700;
    .week-item-day {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: calc((100vw - 1rem) / 7);
      border-radius: 50%;
      font-size: 0.35rem;
    }
    .active {
      color: #fff;
      background-color: #846ffe;
      font-size: 0.45rem;
    }
  }
  .day-item {
    margin: 0.7rem 0;
    .day-item:last-child {
      margin-bottom: 0.3rem;
    }
    .day-item-title {
      margin-bottom: 0.5rem;
      display: flex;
      align-items: center;
      img {
        width: 0.6rem;
        height: 0.6rem;
      }
      span {
        font-weight: 500;
        margin-left: 0.3rem;
      }
    }
    .food-item {
      margin: 0.15rem 0;
      display: flex;
      align-items: center;
      height: 1.2rem;
      img {
        margin-bottom: 0.2rem;
        width: 0.8rem;
        height: 0.8rem;
        border-radius: 0.1rem;
      }
      div {
        margin-left: 0.3rem;
        height: 100%;
        width: 100%;
        line-height: 1.2rem;
        font-size: 0.28rem;
      }
    }
  }
  .day-item:last-child {
    margin-bottom: 0;
  }
  .no-day-recipe {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 6rem;
    img {
      width: 2rem;
      height: 2rem;
    }
    p {
      margin-top: 0.2rem;
      font-size: 0.3rem;
      color: rgba(0, 0, 0, 0.24);
    }
  }
}
</style>